module.exports = __webpack_public_path__ + "static/media/night.57b3eca3.png";